import { useState } from 'react'
import { client } from '@lib/api'
import * as Sentry from '@sentry/react'

export type PpobProductCategory = 'PULSA' | 'PAKET_DATA' | 'INTERNET' | 'PLN' | 'EMONEY' | 'ESIM'

type PpobService = {
  id: number
  code: string
  category: PpobProductCategory
  name: string
  description: string
  image_url: string
  mobile_navigate_to?: string
  tma_navigate_to?: string
  is_active: boolean
  created_at: string
  updated_at: string
}

type Response = {
  services: PpobService[]
  total: number
}

export const usePpobServices = () => {
  const [services, setServices] = useState<PpobService[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [total, setTotal] = useState(0)

  async function getPpobServices() {
    setIsLoading(true)
    setServices([])
    try {
      const response = await client.doGet<Response>('/wallet/ppob/services')

      if (response?.services && Array.isArray(response.services)) {
        setServices(response.services)
        setTotal(response.total)
      }
    } catch (error) {
      Sentry.captureException(error, {
        tags: { feature: 'ppob', service: 'services-list' }
      })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    services,
    getPpobServices,
    isLoading,
    total,
  }
}
